import React, { useEffect, useState } from 'react';
import Autocomplete, { highlightSubstring } from '../Autocomplete';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import gravatarUrl from '@afosto/utils/gravatarUrl';
import { users as usersApi } from '@afosto/iam/api/Users';

const UserSearch = props => {
  const [userSuggestions, setUserSuggestions] = useState([]);
  const [isFetchingUsers, setIsFetchingUsers] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchUsers = async () => {
      try {
        setIsFetchingUsers(true);

        const response = await usersApi.listUsers(
          { isPendingInvite: 0 },
          {
            headers: {
              'x-page': 1,
              'x-page-size': 100,
            },
          },
        );
        const { data } = response;

        const formattedUsers = data.reduce(
          (acc, user) => [
            ...acc,
            {
              ...user,
              label: `${user.first_name} ${user.last_name}`,
              value: user.id,
            },
          ],
          [],
        );

        if (isMounted) {
          setUserSuggestions(formattedUsers);
        }
        return formattedUsers;
      } catch (err) {
        if (isMounted) {
          setUserSuggestions([]);
        }
        return [];
      } finally {
        setIsFetchingUsers(false);
      }
    };

    fetchUsers();

    return () => {
      isMounted = false;
    };
  }, []);

  const renderUserOptions = (option, { inputValue = '' } = {}) => {
    let label = option;

    if (typeof option === 'object') {
      // eslint-disable-next-line prefer-destructuring
      label = option.label;
    }

    return (
      <ListItem component="div" dense disableGutters>
        <ListItemAvatar>
          <Avatar alt={label} src={gravatarUrl(option.email, { letterValue: label })} />
        </ListItemAvatar>
        <ListItemText
          primary={highlightSubstring(label, inputValue)}
          secondary={highlightSubstring(option.email, inputValue)}
        />
      </ListItem>
    );
  };

  return (
    <Autocomplete
      {...props}
      options={userSuggestions}
      renderOption={renderUserOptions}
      loading={isFetchingUsers}
    />
  );
};

export default UserSearch;
